export function isSafari() {
  const { userAgent } = navigator;

  // Safari's user agent string contains 'Safari' and does not contain 'Chrome' or 'Chromium'
  if (
    userAgent.includes('Safari') &&
    userAgent.includes('Chrome') === false &&
    userAgent.includes('Chromium') === false
  ) {
    return true;
  }

  return false;
}
